import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { apiPatch } from '../../utils/api';
import toast from 'react-hot-toast';

const AuditAssignmentPanel = ({ property, teamMembers = [], onAssigned }) => {
  const { theme } = useTheme();
  const { currentUser } = useAuth();
  const isDark = theme === 'dark';
  const [assigning, setAssigning] = useState(false);

  const handleAssign = async (userId) => {
    setAssigning(true);
    try {
      const response = await apiPatch(`/admin/audit_tracker/properties/${property.id}/assign`, {
        assigned_to_id: userId || null,
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to assign');
      }
      const data = await response.json();
      toast.success(data.message);
      if (onAssigned) onAssigned(data.property);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setAssigning(false);
    }
  };

  // Build unique list: team members + current user (so directors can assign themselves)
  const memberIds = new Set(teamMembers.map((m) => m.user_id || m.id));
  const options = [...teamMembers];
  if (currentUser && !memberIds.has(currentUser.public_id) && !memberIds.has(String(currentUser.id))) {
    options.unshift({
      user_id: currentUser.id,
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      username: currentUser.username,
      email: currentUser.email,
      role: currentUser.role,
    });
  }

  return (
    <div className="flex items-center gap-2">
      <select
        value={property.assigned_to?.id || ''}
        onChange={(e) => handleAssign(e.target.value)}
        disabled={assigning}
        className={`text-sm px-3 py-1.5 rounded-lg border ${
          isDark
            ? 'bg-gray-700 border-gray-600 text-gray-200'
            : 'bg-white border-gray-300 text-gray-700'
        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
      >
        <option value="">Unassigned</option>
        {options.map((m) => {
          const name = m.first_name ? `${m.first_name} ${m.last_name || ''}`.trim() : m.username || m.email;
          const roleLabel = m.role ? ` (${m.role})` : '';
          return (
            <option key={m.user_id || m.id} value={m.user_id || m.id}>
              {name}{roleLabel}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default AuditAssignmentPanel;
